import { createReducer, on } from '@ngrx/store';
import * as potentialConsequence from '../actions/potential-consequence.actions';
import { PotentialConsequence } from '../../models/potential-consequence.model';

export interface PotentialConsequenceState {
  potentialConsequences: PotentialConsequence[];
  error: any;
  loading: boolean;
}

export const initialState: PotentialConsequenceState = {
  potentialConsequences: [],
  error: null,
  loading: true,
};

export const potentialConsequenceReducer = createReducer(
  initialState,

  // Load actions
  on(potentialConsequence.loadPotentialConsequences , (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(
    potentialConsequence.loadPotentialConsequencesSuccess,
    (state, { potentialConsequences }) => ({
      ...state,
      potentialConsequences,
      loading: false,
      error: null,
    })
  ),

  on(potentialConsequence.loadPotentialConsequencesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Batch operations loading states
  on(
    potentialConsequence.deleteMultiplePotentialConsequences,
    potentialConsequence.createMultiplePotentialConsequences,
    potentialConsequence.updateMultiplePotentialConsequences,
    (state) => ({
      ...state,
      loading: true,
      error: null,
    })
  ),

  on(
    potentialConsequence.deleteMultiplePotentialConsequencesSuccess,
    (state, { uids }) => ({
      ...state,
      potentialConsequences: state.potentialConsequences.filter(
        (consequence) => !uids.includes(consequence.uid)
      ),
      loading: false,
      error: null,
    })
  ),

  on(
    potentialConsequence.createMultiplePotentialConsequencesSuccess,
    (state, { potentialConsequences }) => ({
      ...state,
      potentialConsequences: [...state.potentialConsequences, ...potentialConsequences],
      loading: false,
      error: null,
    })
  ),

  on(
    potentialConsequence.updateMultiplePotentialConsequencesSuccess,
    (state, { potentialConsequences }) => ({
      ...state,
      potentialConsequences: state.potentialConsequences.map((potentialConsequence) => {
        const updated = potentialConsequences.find((ps) => ps.uid === potentialConsequence.uid);
        return updated || potentialConsequence;
      }),
      loading: false,
      error: null,
    })
  ),

  // Error handling
  on(
    potentialConsequence.deleteMultiplePotentialConsequencesFailure,
    potentialConsequence.createMultiplePotentialConsequencesFailure,
    potentialConsequence.updateMultiplePotentialConsequencesFailure,
    (state, { error }) => ({
      ...state,
      loading: false,
      error,
    })
  )
);
